import { Button, Collapse, IconButton } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { updateProject } from '../../../actions/projectActions'
import { MACHINE_UPDATE_RESET } from '../../../constants/machineConstants'
import { PART_UPDATE_RESET } from '../../../constants/partConstants'
import { PROGRAM_UPDATE_RESET } from '../../../constants/programConstants'
import { useQuoteCalculator } from '../../../hooks/useQuoteCalculator'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import ToastMessage from '../../ToastMessage/ToastMessage'
import CombinedSummary from './CombinedSummary'
import MachineSummary from './MachineSummary'
import PartSummary from './PartSummary'
import ProgramSummary from './ProgramSummary'
import ReportSummary from './ReportSummary'

const Request = ({ request, index, isRequestSummary }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [expanded, setExpanded] = useState(isRequestSummary)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [partDetails, setPartDetails] = useState({})
  const [machineDetails, setMachineDetails] = useState({})
  const [programs, setPrograms] = useState({})
  const [loading, setLoading] = useState(false)
  const [partToast, setPartToast] = useState(false)
  const [partName, setPartName] = useState('')
  const [machineToast, setMachineToast] = useState(false)
  const [machineName, setMachineName] = useState('')
  const [programToast, setProgramToast] = useState(false)
  const [programName, setProgramName] = useState('')

  const { project } = useSelector((state) => state.projectDetails)
  const { userInfo } = useSelector((state) => state.userLogin)
  const { part: updatedPart, success: partUpdateSuccess } = useSelector(
    (state) => state.partUpdate
  )
  const { machine: updatedMachine, success: machineUpdateSuccess } =
    useSelector((state) => state.machineUpdate)
  const { program: updatedProgram, success: programUpdateSuccess } =
    useSelector((state) => state.programUpdate)

  const programCost = useQuoteCalculator(programs)
  const partCost = useQuoteCalculator({
    type: 'programming',
    payload: partDetails,
  })

  useEffect(() => {
    if (!userInfo) {
      history.push(`/login?redirect=${window.location.pathname}`)
    }

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const getPartDetails = async (id) => {
      try {
        setLoading(true)
        const { data } = await axios.get(`/api/parts/details/${id}`, config)
        setPartDetails(data)

        if (data) {
          setLoading(false)
        }
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    }

    const getMachineDetails = async (id) => {
      try {
        setLoading(true)

        const { data } = await axios.get(`/api/machines/details/${id}`, config)
        setMachineDetails(data)

        if (data) {
          setLoading(false)
        }
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    }

    const getProgramCollectionDetails = async (details) => {
      try {
        setLoading(true)

        const { data } = await axios.post(
          `/api/programs/collection/`,
          details,
          config
        )

        setPrograms(data)

        if (data) {
          setLoading(false)
        }
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    }

    if (request.type === 'inspection') {
      getProgramCollectionDetails({ details: request.programDetails })
    }

    if (!partDetails.name && userInfo.firstName !== '') {
      getPartDetails(request.part)

      if (request.machine !== '') {
        getMachineDetails(request.machine)
      }
    }

    if (machineUpdateSuccess) {
      setMachineToast(true)
      setMachineName(updatedMachine.name)
      dispatch({ type: MACHINE_UPDATE_RESET })
      getMachineDetails(request.machine)
    }

    if (partUpdateSuccess) {
      setPartToast(true)
      setPartName(updatedPart.name)
      dispatch({ type: PART_UPDATE_RESET })
      getPartDetails(request.part)
    }

    if (programUpdateSuccess) {
      setProgramToast(true)
      setProgramName(updatedProgram.name)
      dispatch({ type: PROGRAM_UPDATE_RESET })
      getProgramCollectionDetails({ details: request.programDetails })
    }
  }, [
    request,
    partDetails,
    userInfo,
    history,
    machineUpdateSuccess,
    setMachineToast,
    dispatch,
    updatedMachine,
    partUpdateSuccess,
    programUpdateSuccess,
    updatedPart,
    updatedProgram,
  ])

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const handleRemoveClick = () => {
    setShowDeleteModal(true)
  }

  const handleDelete = () => {
    let projectClone = project

    projectClone.requests.splice(index, 1)

    setShowDeleteModal(false)
    dispatch(updateProject(projectClone))
  }

  return (
    <div className="request">
      <div className="flex space-between">
        <div className="flex">
          <div>
            {!isRequestSummary && (
              <IconButton
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
                className={`m-r-10 ${expanded ? 'rotate' : ''}`}
                disabled={loading}
              >
                <ChevronRight />
              </IconButton>
            )}
          </div>
          <div>
            <h4 className="m-b-0">{partDetails.name}</h4>
            <p className="m-b-0 gray-text fs14">
              {request.type === 'programming' && 'Contract programming request'}
              {request.type === 'inspection' && 'Contract inspection request'}
              {request.type === 'combined' &&
                'Contract inspection request with contract programming'}
            </p>
          </div>
        </div>

        <div className="text-right">
          {request.type === 'inspection' && (
            <h4 className="m-b-0 m-r-16">
              {isNaN(programCost)
                ? 'TBD'
                : `$${Number(programCost.toFixed(0)).toLocaleString()}`}
            </h4>
          )}
          {request.type === 'programming' && (
            <h4 className="m-b-0 m-r-16">
              {isNaN(partCost)
                ? 'TBD'
                : `$${Number(partCost.toFixed(0)).toLocaleString()}`}
            </h4>
          )}
          {!isRequestSummary && (
            <Button
              className="text"
              color="primary"
              onClick={handleRemoveClick}
            >
              Remove
            </Button>
          )}
        </div>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <PartSummary
          part={partDetails}
          type={request.type}
          qty={request.programDetails && request.programDetails.qty}
        />
        {request.machine && <MachineSummary machine={machineDetails} />}
        {request.programDetails !== undefined &&
          request.programDetails.programs.map((program, index) => (
            <ProgramSummary
              program={program}
              key={index}
              qty={request.programDetails.qty}
            />
          ))}

        {request.type === 'combined' && request.programDetails.notes !== '' && (
          <CombinedSummary
            notes={request.programDetails.notes}
            qty={request.programDetails.qty}
          />
        )}
        <ReportSummary request={request} index={index} />
      </Collapse>

      <ModalPopUp
        title="Delete request?"
        setShowModal={setShowDeleteModal}
        showModal={showDeleteModal}
      >
        <h4 className="m-b-32">Delete request?</h4>
        <p>Are you sure you want to delete {partDetails.name}?</p>
        <div className="actions m-t-40 flex-end flex">
          <Button
            color="primary"
            variant="outlined"
            className="m-r-24"
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button color="primary" variant="contained" onClick={handleDelete}>
            Confirm
          </Button>
        </div>
      </ModalPopUp>

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Machine updated</p>
            <p className="fs14 m-b-0">
              You successfully updated {machineName}.
            </p>
          </>
        }
        open={machineToast}
        setOpen={setMachineToast}
      />

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Part updated</p>
            <p className="fs14 m-b-0">You successfully updated {partName}.</p>
          </>
        }
        open={partToast}
        setOpen={setPartToast}
      />

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Program updated</p>
            <p className="fs14 m-b-0">
              You successfully updated {programName}.
            </p>
          </>
        }
        open={programToast}
        setOpen={setProgramToast}
      />
    </div>
  )
}

export default Request
